import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import Modal from 'modules/common/components/Modal';
import withForm from 'modules/common/hoc/withForm';
import moment from 'moment';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import * as actions from '../action';
import * as c from '../constant';

function GeneratePermitModal({
  data,
  id,
  setFormData,
  formData,
  showTransaction,
  generating,
  generatePermit
}) {
  const setModal = useContext(ModalContext);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e ? e.target.value : '',
    });
  };

  const handleOnChangeDate = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      permit_validity: moment(_.get(formData, 'permit_validity')).format('YYYY-MM-DD'),
    }

    generatePermit(id, args, () => {
      setModal({ isOpen: false });
      showTransaction(id);
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        {_.get(data, 'attributes.is_valid_bus_plate_number') === 0 &&
        _.get(data, 'attributes.type') === 'PUV' ? (
          <div className="col-12 form-group">
            <label className="form-label">Bus Plate Number :</label>
            <input
              className="form-control"
              type="text"
              name="bus_plate_number"
              onChange={onChange}
              value={_.get(formData, 'bus_plate_number') || ''}
            />
          </div>
        ) : ''}
        <div className="col-12 form-group">
          <label className="form-label">Permit Validity :</label>
          <DateInputPicker
            className="full-input"
            dateFormat="MM/DD/YYYY"
            minDate={moment().add(1, 'days')._d}
            onChange={handleOnChangeDate('permit_validity')}
            value={_.get(formData, 'permit_validity') || ''}
          />
        </div>        
        <div className="d-flex justify-content-center">
          <button
            disabled={generating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {generating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={generating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

GeneratePermitModal.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  generating: PropTypes.bool.isRequired,
  generatePermit: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  generating: api.loading.indexOf(c.GENERATE_PERMIT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(GeneratePermitModal);
